// extracted by mini-css-extract-plugin
module.exports = {"category":"SupportCategory_category__1XnBe"};